import styled from 'styled-components';
import React from 'react';
import { Button } from 'antd';

const StyledBtn = styled(Button)`
  margin: 0 10px 0 0;
`;
export const ButtonWrapper = ({ children, ...rest }) => <StyledBtn {...rest}>{children}</StyledBtn>;
